export { UserInfo } from './UserInfo';


// WEBPACK FOOTER //
// ./src/components/UserInfo/index.js